export default __webpack_public_path__ + "static/media/img7.b0871d92.png";